/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

export const getContainerPadding = () => {
    return (props: any) => {
        const theme = props.theme || baseTheme;
        const { containerPadding } = theme.breakpoints;
        const padding = merge([0, 0, 0, 0, 0], containerPadding);

        return breakpointMediaQueries(theme, [
            css`
                padding: ${padding[0]};
            `,
            css`
                padding: ${padding[1]};
            `,
            css`
                padding: ${padding[2]};
            `,
            css`
                padding: ${padding[3]};
            `,
            css`
                padding: ${padding[4]};
            `,
        ]);
    };
};

export default getContainerPadding;
